
import Scissor from "../../../assets/outline/Scissor.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ScissorIcon({ className, dataTestid = "ScissorIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Scissor data-testid={dataTestid} className={classes} {...rest} />
  );
}
